const list = {
    or: 'or',
    and: 'and',
    separator: ',',
};
export default Object.freeze(list);
